import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    getMembershipList,
    saveMembership as apiSaveMembership,
    toggleMembershipStatus as apiToggleMembershipStatus,
} from '../../services/api';

export const fetchMemberships = createAsyncThunk(
    'membership/fetchMemberships',
    async ({ perPage, page, keyword = null, is_active = null }, { rejectWithValue }) => {
        try {
            const response = await getMembershipList(perPage, page, keyword, is_active);
            // response = { status, message, data: <laravel paginator> }
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const saveMembership = createAsyncThunk(
    'membership/saveMembership',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await apiSaveMembership(payload);
            if (response.status && response.status.success === false) {
                return rejectWithValue(response);
            }
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const toggleMembershipStatus = createAsyncThunk(
    'membership/toggleMembershipStatus',
    async (program_id, { rejectWithValue }) => {
        try {
            const response = await apiToggleMembershipStatus(program_id);
            return { program_id, response };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const membershipSlice = createSlice({
    name: 'membership',
    initialState: {
        memberships: [],
        loading: false,
        saving: false,
        error: null,
        currentPage: 1,
        totalPages: 1,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMemberships.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMemberships.fulfilled, (state, action) => {
                state.loading = false;
                state.memberships = action.payload?.data || [];
                state.currentPage = action.payload?.current_page || 1;
                state.totalPages = action.payload?.last_page || 1;
            })
            .addCase(fetchMemberships.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload?.message || 'Failed to load memberships';
            })
            .addCase(saveMembership.pending, (state) => {
                state.saving = true;
                state.error = null;
            })
            .addCase(saveMembership.fulfilled, (state) => {
                state.saving = false;
            })
            .addCase(saveMembership.rejected, (state, action) => {
                state.saving = false;
                state.error = action.payload?.message || 'Save failed';
            })
            .addCase(toggleMembershipStatus.fulfilled, (state, action) => {
                const item = state.memberships.find((m) => m.program_id === action.payload.program_id);
                if (item) {
                    item.is_active = !item.is_active;
                }
            });
    },
});

export default membershipSlice.reducer;